import styled from "styled-components"

const Title = styled.h2`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`
const Wrapper = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light + 55};
`
export { Title, Wrapper }
